import { createSlice } from '@reduxjs/toolkit';

import { fetchArticleLinks } from './articleLinks.actions';
import { ArticleLinksSlice, defaultArticleLinksSlice } from './articleLinks.types';

const isCurrentNavigation = (state: ArticleLinksSlice, navigationId: number) => navigationId === state.navigationId;

const articleLinksSlice = createSlice({
    extraReducers: (builder) => {
        builder
            .addCase(fetchArticleLinks.pending, (state, action) => {
                if (!isCurrentNavigation(state, action.meta.arg.navigationId)) {
                    return;
                }
                state.links = [];
            })
            .addCase(fetchArticleLinks.fulfilled, (state, action) => {
                if (!isCurrentNavigation(state, action.meta.arg.navigationId)) {
                    return;
                }
                state.links = action.payload;
            })
            .addCase(fetchArticleLinks.rejected, (state, action) => {
                if (!isCurrentNavigation(state, action.meta.arg.navigationId)) {
                    return;
                }
                state.links = [];
            });
    },
    initialState: defaultArticleLinksSlice,
    name: 'articleLinks',
    reducers: {
        startArticleLinksNavigation: (state) => ({
            ...defaultArticleLinksSlice,
            navigationId: state.navigationId + 1,
        }),
    },
});

export const { startArticleLinksNavigation } = articleLinksSlice.actions;
export const { reducer: articleLinksReducer } = articleLinksSlice;
